import { render, staticRenderFns } from "./co-my-pages.vue?vue&type=template&id=5cb8d2b5&"
import script from "./co-my-pages.vue?vue&type=script&lang=ts&"
export * from "./co-my-pages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports